import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './HidePosting.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HidePostingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type HidePostingMutation = (
  { __typename?: 'Mutation' }
  & { postingsHidePosting?: Types.Maybe<(
    { __typename?: 'PostingsPostingMutationResult' }
    & { success?: Types.Maybe<(
      { __typename?: 'PostingsPosting' }
      & Pick<Types.PostingsPosting, 'id'>
    )>, error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type HidePostingMutationFn = Apollo.MutationFunction<HidePostingMutation, HidePostingMutationVariables>;

/**
 * __useHidePostingMutation__
 *
 * To run a mutation, you first call `useHidePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHidePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hidePostingMutation, { data, loading, error }] = useHidePostingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHidePostingMutation(baseOptions?: Apollo.MutationHookOptions<HidePostingMutation, HidePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HidePostingMutation, HidePostingMutationVariables>(Operations.hidePosting, options);
      }
export type HidePostingMutationHookResult = ReturnType<typeof useHidePostingMutation>;
export type HidePostingMutationResult = Apollo.MutationResult<HidePostingMutation>;
export type HidePostingMutationOptions = Apollo.BaseMutationOptions<HidePostingMutation, HidePostingMutationVariables>;